import { componentName, UserAuthMethodClass } from './UserAuthMethodClass';
import '@descope-ui/descope-text';
import '@descope-ui/descope-button';
import '@descope-ui/descope-badge';
import '@vaadin/icon';

customElements.define(componentName, UserAuthMethodClass);

export { UserAuthMethodClass, componentName };
